import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '../ui/AlertDialog'
import { useVariableValue, useDevCycleClient } from '@devcycle/react-client-sdk'

const getDialogContent = (flagName: string) => {
  const content = {
    ['restricted-user-accounts']: {
      title: 'Free Access Ended.',
      description: `Upgrade now to unlock full access and premium features,
        <br /> Your data is still saved and ready to review anytime.`,
      buttonText: 'Upgrade Now'
    },
    ['allowed-organization-domains']: {
      title: 'Access Restricted.',
      description: `Your organization is not allowed to run reviews until you have been fully onboarded.
        <br />Please contact support to get full access.`,
      buttonText: 'Contact Support'
    }
  }

  return content[flagName as keyof typeof content]
}

export function FreeTierEndedDialog() {
  const devcycleClient = useDevCycleClient()
  const isFreeTierEnded = useVariableValue('restricted-user-accounts', false)
  const isAllowedOrgDomain = useVariableValue('allowed-organization-domains', true)

  if (!devcycleClient.isInitialized) return null
  if (!isFreeTierEnded && isAllowedOrgDomain) return null

  const modalOpen = isFreeTierEnded || !isAllowedOrgDomain

  const { title, description, buttonText } = isFreeTierEnded
    ? getDialogContent('restricted-user-accounts')
    : getDialogContent('allowed-organization-domains')

  return (
    <AlertDialog defaultOpen={modalOpen} key={modalOpen ? 'open' : 'closed'}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription dangerouslySetInnerHTML={{ __html: description }} />
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              window.location.href = 'mailto:support@mbue.ai'
            }}
          >
            {buttonText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
